<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<script>
import Base from '@views/Base.vue'
import pc from './plugins/Header.vue'
import mobile from './plugins/Header.mobile.vue'

export default {
  extends: Base,
  mounted() {
    this.setLoadComponent(pc, mobile)
  },
}
</script>

<style lang="scss" scoped></style>
